import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.StepDeadline.SelectorDeadline', {
    title: 'Deadline settings',
    days: '{count, plural, one {Day} other {Days}}',
    hours: '{count, plural, one {Hour} other {Hours}}',
});
